import { ref } from 'vue';
import axios from 'axios';
const getUser = (id) => {
    const user = ref([]);
    const error = ref('');
    try {
        const loadUser = async () => {
            await axios
                .get(axios.defaults.baseUrl + "getUser/" + id,
                    {
                        headers: {
                            Authorization: "Bearer " + localStorage.getItem('auth_token'),
                        },
                    }
                )
                .then((response) => {
                    user.value = response.data;
                })
                .catch((error) => {
                    error.value = 'No User Data found';
                });
        }
        return { user, error, loadUser };
    } catch (error) {
        error.value = 'No User Data found';
    }
}
export default getUser;